// app
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_FIRSTLOGIN = 'SET_FIRSTLOGIN'
export const SET_SLIDERSTATE = 'SET_SLIDERSTATE'
export const SET_LOCK_STATE = 'SET_LOCK_STATE'

// user
export const SET_TOKEN = 'SET_TOKEN'
//export const SET_ROLES = 'SET_ROLES'
export const SET_INTRODUCTION = 'SET_INTRODUCTION'
export const SET_NAME = 'SET_NAME'
export const SET_AVATAR = 'SET_AVATAR'

// permission
export const SET_ROUTERS = 'SET_ROUTERS'

// tagsview
export const ADD_VISITED_TAG = 'ADD_VISITED_TAG'
export const REMOVE_VISITED_TAG = 'REMOVE_VISITED_TAG'
export const CLOSE_OTHER_TAG = 'CLOSE_OTHER_TAG'
export const CLOSE_ALL_TAG = 'CLOSE_ALL_TAG'
export const SET_VIEWS = 'SET_VIEWS'
// export const ADD_VISITED_VIEW = 'ADD_VISITED_VIEW'
// export const ADD_CACHED_VIEW = 'ADD_CACHED_VIEW'
// export const DEL_VISITED_VIEW = 'DEL_VISITED_VIEW'
// export const DEL_CACHED_VIEW = 'DEL_CACHED_VIEW'
// export const DEL_OTHERS_VISITED_VIEWS = 'DEL_OTHERS_VISITED_VIEWS'
// export const DEL_OTHERS_CACHED_VIEWS = 'DEL_OTHERS_CACHED_VIEWS'
// export const DEL_ALL_VISITED_VIEWS = 'DEL_ALL_VISITED_VIEWS'
// export const DEL_ALL_CACHED_VIEWS = 'DEL_ALL_CACHED_VIEWS'
// export const UPDATE_VISITED_VIEW = 'UPDATE_VISITED_VIEW'
